import React from 'react';

export default function CountDownTimer({ countDownTime, countdownActive }) {
  const [seconds, setSeconds] = React.useState(countDownTime);

  React.useEffect(() => {
    if (countdownActive && seconds > 0) {
      setTimeout(() => {
        setSeconds(prev => prev - 1);
      }, 1000);
    }

    if (!countdownActive) {
      setSeconds(countDownTime)
    }
  }, [seconds, countdownActive]);

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const remainingSeconds = timeInSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  };
  return (
    <span className='b-typography-sans-serif--body--100 b-font-weight-bold' id='countdown-timer'>
      {formatTime(seconds)}
    </span>
  );
}
